// import Vue from 'vue'
// import VueRouter from 'vue-router'
import Home from "@/pages/home/Home";
import Term from "@/pages/common/Term";
import Privacy from "@/pages/common/Privacy";
import Protocol from "@/pages/common/Protocol";
import Error404 from "@/pages/common/Error404";
import Gateway from "@/pages/common/Gateway";
import RemittanceAccount from "@/pages/common/RemittanceAccount";
import Login from "@/pages/login/Login";
import UserCenterReturn from "@/pages/login/UserCenterReturn";
import Product from "@/pages/product/Product";
import OrderConfirm from "@/pages/order/OrderConfirm";
import OrderPay from "@/pages/order/OrderPay";
import PayQRCode from "@/pages/pay/PayQRCode";
import RechargePayQRCode from "@/pages/pay/RechargePayQRCode";
import PayTrans from "@/pages/pay/PayTrans";
import PayReturn from "@/pages/pay/PayReturn";
import RechargePayReturn from "@/pages/pay/RechargePayReturn";
import QiYeWeiXinPay from "@/pages/pay/QiYeWeiXinPay";
import OrderRechargePay from "@/pages/order/OrderRechargePay";
import Personal from "@/pages/personal/Personal";
import OrderList from "@/pages/personal/OrderList";
import OrderDetail from "@/pages/order/OrderDetail";
import InvoiceDetail from "@/pages/invoice/InvoiceDetail";
import PowerList from "@/pages/personal/PowerList";
import ExtraProduct from "@/pages/personal/ExtraProduct";
import CardPay from "@/pages/personal/CardPay";
import Coupon from "@/pages/personal/Coupon.vue";
import CardList from "@/pages/personal/CardList";
import ClientProduct from "@/pages/client/Product";
import ClientOrder from "@/pages/client/Order";
import ClientPayFinsh from "@/pages/client/PayFinsh";
import ClientRenewTip from "@/pages/client/RenewTip";
import ClientZjsl2Active from "@/pages/client/Zjsl2Active";
// 活动页面
import GiftPages from "@/pages/activity/GiftPages";
import Summer202008 from "@/pages/activity/Summer202008";
import GiftPages08 from "@/pages/activity/GiftPages08";
import OYB116 from "@/pages/activity/OYB116new";
import OYB338 from "@/pages/activity/OYB338";
import FreeTarget from "@/pages/market/FreeTarget";
import Free333 from "@/pages/activity/Free333";
import Free333Success from "@/pages/activity/Free333Success";
import DoubelEleven1 from "@/pages/activity/DoubelEleven1";
import DoubelEleven2 from "@/pages/activity/DoubelEleven2";
import DoubelEleven3 from "@/pages/activity/DoubelEleven3";
import FiveStep2021 from "@/pages/activity/FiveStep2021";
import Znfp2021 from "@/pages/activity/Znfp2021";
import BuyOne202104 from "@/pages/activity/BuyOne202104";
import celebrate519 from "@/pages/activity/celebrate519";
import activity202106 from "@/pages/activity/activity202106";
import activity202107 from "@/pages/activity/activity202107";
import activity202108 from "@/pages/activity/activity202108";
import activity202109 from "@/pages/activity/activity202109";
import activity202110 from "@/pages/activity/activity202110";
import activity202111 from "@/pages/activity/activity202111";
import activity2021112 from "@/pages/activity/activity2021112";
import activityTiger from "@/pages/activity/activityTiger";
import activity202203 from "@/pages/activity/activity202203";
import activity202204 from "@/pages/activity/activity202204";
import activity519 from "@/pages/activity/activity519";
import activity618 from "@/pages/activity/activity618";
import activity0728 from "@/pages/activity/activity0728";
import activity202210 from "@/pages/activity/activity202210";
import activity202212 from "@/pages/activity/activity202212";
import OrderConfirm335 from "@/pages/order/OrderConfirm335";
import activity202304 from "@/pages/activity/activity202304";
import activity202305 from "@/pages/activity/activity202305";
import activity202309 from "@/pages/activity/activity202309";
import activity20231111 from "@/pages/activity/activity20231111";
import activity202311112 from "@/pages/activity/activity202311112";
import activity202311113 from "@/pages/activity/activity202311113";
import activity2023114 from "@/pages/activity/activity2023114";
import activity2023115 from "@/pages/activity/activity2023115";
import activity2023116 from "@/pages/activity/activity2023116";
import activityforecast2024 from "@/pages/activity/activityforecast2024.vue";
import activityTopTen2023 from "@/pages/activity/activityTopTen2023.vue";
import activityBigNote2023 from "@/pages/activity/activityBigNote2023.vue";
import activityInstitutionStrategy2024 from "@/pages/activity/activityInstitutionStrategy2024.vue";
import JumpPage from "@/pages/common/JumpPage";
import WisdomLecture from "@/pages/client/WisdomLecture";
import FunProduct from "@/pages/client/FunProduct";
import activity20240117 from "@/pages/activity/activity20240117";
import activity20240301 from "@/pages/activity/activity20240301";
import activity20240302 from "@/pages/activity/activity20240302";
import activity20240303 from "@/pages/activity/activity20240303";
import activity20240401 from "@/pages/activity/activity20240401";
import activity20240402 from "@/pages/activity/activity202405143";
import activity20240403 from "@/pages/activity/activity202405145";
import activity20240404 from "@/pages/activity/activity202405142";
import activity20240405 from "@/pages/activity/activity20240405";
import activity20240406 from "@/pages/activity/cysw";

import activity202405141 from "@/pages/activity/activity202405141"; //开发 王臣
import activity202405142 from "@/pages/activity/activity202405142"; //开发 王臣
import activity202405143 from "@/pages/activity/activity202405143"; //开发 王臣
import activity202405144 from "@/pages/activity/activity202405144"; //开发 王臣
import activity202405145 from "@/pages/activity/activity202405145"; //开发 王臣
import junActivity from "@/pages/activity/junActivity"; //开发 王臣
import junActivitySpecialty from "@/pages/activity/junActivitySpecialty"; //开发 王臣 20240605g
import junActivity2 from "@/pages/activity/junActivity2"; //开发 王臣 20240613
import junActivitySpecialty2 from "@/pages/activity/junActivitySpecialty2"; //开发 王臣 20240613
import newUserActivity0628 from "@/pages/activity/newUserActivity0628"; //开发 王臣 20240708
import agree_1 from "@/pages/activity/agree_1"; //开发 王臣 20240717  大智慧软件产品自动续费服务协议
// import cysw from "@/pages/activity/cysw"; //开发 王臣 20240703
import _20240801 from "@/pages/activity/_20240801"; //开发 王臣 20240801  8月份活动
import activity20240801 from "@/pages/activity/activity20240801"; //开发 王臣 20240801  8月份活动
import activity20240913 from "@/pages/activity/activity20240913"; //港股level2商城页面
import activity2024111 from "@/pages/activity/activity2024111";
import activity2024112 from "@/pages/activity/activity2024112";
import activity20250301 from "@/pages/activity/activity20250301";
import activity20250302 from "@/pages/activity/activity20250302";
import activity20250403 from "@/pages/activity/activity20250403";

import activity20250618 from "@/pages/activity/activity20250618";
import activity20250618_2 from "@/pages/activity/activity20250618_2";

Vue.use(VueRouter);

export default new VueRouter({
  fallback: false,
  mode: "history",
  base: "pay-mall",
  linkActiveClass: "is-active",
  routes: [
    {
      path: "/",
      name: "Home",
      component: Home
    },
    {
      path: "/term",
      name: "Term",
      component: Term
    },
    {
      path: "/privacy",
      name: "Privacy",
      component: Privacy
    },
    {
      path: "/protocol",
      name: "Protocol",
      component: Protocol
    },
    {
      path: "/login",
      name: "Login",
      component: Login
    },
    {
      path: "/userCenterReturn",
      name: "UserCenterReturn",
      component: UserCenterReturn
    },
    {
      path: "/product/:id?",
      name: "Product",
      component: Product
    },
    {
      path: "/order/confirm/:productId/:month?",
      name: "OrderConfirm",
      component: OrderConfirm
    },
    {
      path: "/order/pay/:orderId",
      name: "OrderPay",
      component: OrderPay
    },
    {
      path: "/order/detail/:id",
      name: "OrderDetail",
      component: OrderDetail
    },
    {
      path: "/invoice/detail/:orderId",
      name: "InvoiceDetail",
      component: InvoiceDetail
    },
    {
      path: "/pay/qrcode/:orderId/:payMode",
      name: "PayQRCode",
      component: PayQRCode
    },
    {
      path: "/pay/rechargeqrcode/:orderId/:payMoney",
      name: "RechargePayQRCode",
      component: RechargePayQRCode
    },
    {
      path: "/pay/trans/:orderId/:busId/:bankId",
      name: "PayTrans",
      component: PayTrans
    },
    {
      path: "/pay/return",
      name: "PayReturn",
      component: PayReturn
    },
    {
      path: "/pay/rechargeReturn",
      name: "RechargePayReturn",
      component: RechargePayReturn
    },
    {
      path: "/pay/qiyeweixinPay",
      name: "QiYeWeiXinPay",
      component: QiYeWeiXinPay
    },
    {
      path: "/order/recharge/:orderId",
      name: "OrderRechargePay",
      component: OrderRechargePay
    },
    {
      path: "/personal",
      name: "Personal",
      component: Personal,
      redirect: "/personal/orderlist",
      children: [
        {
          path: "orderlist",
          name: "OrderList",
          component: OrderList
        },
        {
          path: "powerlist",
          name: "PowerList",
          component: PowerList
        },
        {
          path: "extraproduct",
          name: "ExtraProduct",
          component: ExtraProduct
        },
        {
          path: "cardpay/:userName",
          name: "CardPay",
          component: CardPay
        },
        {
          path: "coupon",
          name: "Coupon",
          component: Coupon
        },
        {
          path: "cardlist",
          name: "CardList",
          component: CardList
        }
      ]
    },
    {
      path: "/client/product.html",
      name: "ClientProduct",
      component: ClientProduct
    },
    {
      path: "/client/order/:orderId",
      name: "ClientOrder",
      component: ClientOrder
    },
    {
      path: "/client/payfinsh",
      name: "ClientPayFinsh",
      component: ClientPayFinsh
    },
    {
      path: "/client/renewtip",
      name: "ClientRenewTip",
      component: ClientRenewTip
    },
    {
      path: "/client/zjsl2Active",
      name: "ClientZjsl2Active",
      component: ClientZjsl2Active
    },
    {
      path: "/remittanceAccount",
      name: "RemittanceAccount",
      component: RemittanceAccount
    },
    {
      path: "/404",
      name: "Error404",
      component: Error404
    },
    {
      path: "/gateway",
      name: "Gateway",
      component: Gateway
    },
    {
      path: "/JumpPage",
      name: "JumpPage",
      component: JumpPage
    },
    {
      path: "/client/WisdomLecture",
      name: "WisdomLecture",
      component: WisdomLecture
    },
    {
      path: "/client/FunProduct.html",
      name: "FunProduct",
      component: FunProduct
    },
    //活动页面
    {
      path: "/giftPages",
      name: "GiftPages",
      component: GiftPages
    },
    {
      path: "/summer202008",
      name: "Summer202008",
      component: Summer202008
    },
    {
      path: "/activity/oybCover116",
      name: "OYB116",
      component: OYB116
    },
    {
      path: "/activity/oybCover338",
      name: "OYB338",
      component: OYB338
    },
    {
      path: "/activity/free333",
      name: "Free333",
      component: Free333
    },
    {
      path: "/activity/free333Success",
      name: "Free333Success",
      component: Free333Success
    },
    {
      path: "/giftPages08",
      name: "GiftPages08",
      component: GiftPages08
    },
    {
      path: "/market/freeTarget",
      name: "FreeTarget",
      component: FreeTarget
    },
    // 双十一
    {
      path: "/doubelEleven1",
      name: "doubelEleven1",
      component: DoubelEleven1
    },
    {
      path: "/doubelEleven2",
      name: "doubelEleven2",
      component: DoubelEleven2
    },
    {
      path: "/doubelEleven3",
      name: "doubelEleven3",
      component: DoubelEleven3
    },
    // 五步战法
    {
      path: "/fivestep2021",
      name: "fivestep2021",
      component: FiveStep2021
    },
    // 智能复盘
    {
      path: "/activity/znfp2021",
      name: "znfp2021",
      component: Znfp2021
    },
    // 365买一得3
    {
      path: "/activity/buyone202104",
      name: "buyone202104",
      component: BuyOne202104
    },
    // 519庆典
    {
      path: "/activity/celebrate519",
      name: "celebrate519",
      component: celebrate519
    },
    // 618
    {
      path: "/activity/activity202106",
      name: "activity202106",
      component: activity202106
    },
    // 7月
    {
      path: "/activity/activity202107",
      name: "activity202107",
      component: activity202107
    },
    // 8月
    {
      path: "/activity/activity202108",
      name: "activity202108",
      component: activity202108
    },
    // 9月
    {
      path: "/activity/activity202109",
      name: "activity202109",
      component: activity202109
    },
    // 10月
    {
      path: "/activity/activity202110",
      name: "activity202110",
      component: activity202110
    },
    // 11月
    {
      path: "/activity/activity202111",
      name: "activity202111",
      component: activity202111
    },
    // 11月 第二个活动
    {
      path: "/activity/activity2021112",
      name: "activity2021112",
      component: activity2021112
    },
    // 12月
    {
      path: "/activity/activityTiger",
      name: "activityTiger",
      component: activityTiger
    },
    // 2022 3月
    {
      path: "/activity/activity202203",
      name: "activity202203",
      component: activity202203
    },
    // 2022 4月
    {
      path: "/activity/activity202204",
      name: "activity202204",
      component: activity202204
    },
    // 2022 4月 519活动
    {
      path: "/activity/activity519",
      name: "activity519",
      component: activity519
    },
    // 2022 6月 618活动
    {
      path: "/activity/activity618",
      name: "activity618",
      component: activity618
    },
    // 2022 7月 启航版活动
    {
      path: "/activity/activity0728",
      name: "activity0728",
      component: activity0728
    },
    // 2022 10月 优选大师个股
    {
      path: "/activity/activity202210",
      name: "activity202210",
      component: activity202210
    },
    // 2022 12月 双十二
    {
      path: "/activity/activity202212",
      name: "activity202212",
      component: activity202212
    },
    // 335月卡周卡双周卡购买页
    {
      path: "/order/confirmYJT/:month",
      name: "OrderConfirm335",
      component: OrderConfirm335
    },
    // 335双周卡活动 2023 04
    {
      path: "/activity/activity202304",
      name: "activity202304",
      component: activity202304
    },
    // 335双周卡活动 2023 05
    {
      path: "/activity/activity202305",
      name: "activity202305",
      component: activity202305
    },
    // 23年中秋活动 2023 09
    {
      path: "/activity/activity202309",
      name: "activity202309",
      component: activity202309
    },
    // 23年双十一活动 2023 10
    {
      path: "/activity/activity20231111",
      name: "activity20231111",
      component: activity20231111
    },
    // 23年双十一活动 2023 10
    {
      path: "/activity/activity202311112",
      name: "activity202311112",
      component: activity202311112
    },
    // 23年双十一活动 2023 10
    {
      path: "/activity/activity202311113",
      name: "activity202311113",
      component: activity202311113
    },
    // 23年双十一活动 2023 11  365
    {
      path: "/activity/activity2023114",
      name: "activity2023114",
      component: activity2023114
    },
    // 23年双十一活动 2023 11 专业版
    {
      path: "/activity/activity2023115",
      name: "activity2023115",
      component: activity2023115
    },
    // 23年双十一活动 2023 11 免费版
    {
      path: "/activity/activity2023116",
      name: "activity2023116",
      component: activity2023116
    },
    // 2024展望 活动
    {
      path: "/activity/activityforecast2024",
      name: "activityforecast2024",
      component: activityforecast2024
    },
    // 2023 十大牛熊股
    {
      path: "/activity/activityTopTen2023",
      name: "activityTopTen2023",
      component: activityTopTen2023
    },
    // 2023 年资本市场大事记
    {
      path: "/activity/activityBigNote2023",
      name: "activityBigNote2023",
      component: activityBigNote2023
    },
    //机构2024策略前瞻
    {
      path: "/activity/activityInstitutionStrategy2024",
      name: "activityInstitutionStrategy2024",
      component: activityInstitutionStrategy2024
    },
    // 365日常营销-4大投资利器
    {
      path: "/activity/activity20240117",
      name: "activity20240117",
      component: activity20240117
    },
    // 202403 专业版+365
    {
      path: "/activity/activity20240301",
      name: "activity20240301",
      component: activity20240301
    },
    // 202403 专业版
    {
      path: "/activity/activity20240302",
      name: "activity20240302",
      component: activity20240302
    },
    // 202403 免费送365
    {
      path: "/activity/activity20240303",
      name: "activity20240303",
      component: activity20240303
    },
    // 202404 365level2
    {
      path: "/activity/activity20240401",
      name: "activity20240401",
      component: activity20240401
    },
    // 202404 DDE决策
    {
      path: "/activity/activity20240402",
      name: "activity20240402",
      component: activity20240402
    },
    // 202404 抄底资金
    {
      path: "/activity/activity20240403",
      name: "activity20240403",
      component: activity20240403
    },
    // 202404 六脉神剑
    {
      path: "/activity/activity20240404",
      name: "activity20240404",
      component: activity20240404
    },
    // 202404 追击反转
    {
      path: "/activity/activity20240405",
      name: "activity20240405",
      component: activity20240405
    },
    // 202404 超赢思维
    {
      path: "/activity/activity20240406",
      name: "activity20240406",
      component: activity20240406
    },
    //王臣 - 九转交易
    {
      path: "/activity/activity202405141",
      name: "activity202405141",
      component: activity202405141
    },
    //王臣 - 2-六脉神剑
    {
      path: "/activity/activity202405142",
      name: "activity202405142",
      component: activity202405142
    },
    //王臣 - 3-DDE决策
    {
      path: "/activity/activity202405143",
      name: "activity202405143",
      component: activity202405143
    },
    //王臣 - 4-波段线
    {
      path: "/activity/activity202405144",
      name: "activity202405144",
      component: activity202405144
    },
    //王臣 - 5-抄底资金
    {
      path: "/activity/activity202405145",
      name: "activity202405145",
      component: activity202405145
    },
    //王臣 - 6月活动
    {
      path: "/activity/junActivity",
      name: "junActivity",
      component: junActivity
    },

    //王臣 - 6月活动专业版  20240605
    {
      path: "/activity/junActivitySpecialty",
      name: "junActivitySpecialty",
      component: junActivitySpecialty
    },

    //王臣 - 6月活动 下半月  20240613
    {
      path: "/activity/junActivity2",
      name: "junActivity2",
      component: junActivity2
    },

    //王臣 - 6月活动专业版  下半月  20240613
    {
      path: "/activity/junActivitySpecialty2",
      name: "junActivitySpecialty2",
      component: junActivitySpecialty2
    },

    // //王臣 - PC软件功能宣传页-超赢思维  20240703
    // {
    //   path: "/activity/cysw",
    //   name: "cysw",
    //   component: cysw
    // }

    //王臣 - 新用户vip 20240708
    {
      path: "/activity/newUserActivity0628/:orderId",
      name: "newUserActivity0628",
      component: newUserActivity0628
    },

    //王臣 - 新用户vip 20240717  大智慧软件产品自动续费服务协议

    {
      path: "/activity/agree_1",
      name: "agree_1",
      component: agree_1
    },

    //王臣 - 8月份活动_20240801

    {
      path: "/activity/_20240801",
      name: "_20240801",
      component: _20240801
    },
    {
      path: "/activity/activity20240801",
      name: "activity20240801",
      component: activity20240801
    },
    {
      path: "/activity/activity2024111",
      name: "activity2024111",
      component: activity2024111
    },
    {
      path: "/activity/activity2024112",
      name: "activity2024112",
      component: activity2024112
    },
    {
      path: "/activity/activity20240913",
      name: "activity20240913",
      component: activity20240913
    },
    {
      path: "/activity/activity20250301",
      name: "activity20250301",
      component: activity20250301
    },
    {
      path: "/activity/activity20250302",
      name: "activity20250302",
      component: activity20250302
    },
    {
      path: "/activity/activity20250403/:orderId",
      name: "activity20250403",
      component: activity20250403
    },
    {
      path: "/activity/activity20250618",
      name: "activity20250618",
      component: activity20250618
    },
    {
      path: "/activity/activity20250618_2",
      name: "activity20250618_2",
      component: activity20250618_2
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js